import React from 'react';
import { Text } from '@mantine/core';
import { SearchResultItem } from './SearchResultItem';
import { RecentSearchItem } from './RecentSearchItem';
import type { SearchResultsProps } from '../types';
import styles from './SearchResults.module.css';

export const SearchResults = React.memo<SearchResultsProps>(({
  results,
  selectedIndex,
  onSelectResult,
  showRecentSearches,
  recentSearches,
  onSelectRecentSearch,
  error,
}) => {
  if (error) {
    return (
      <div className={styles.errorMessage}>
        <Text size="sm" c="red" ta="center">
          {error}
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.scrollContainer}>
      {showRecentSearches && recentSearches.map((recentSearch, index) => (
        <RecentSearchItem
          key={recentSearch.id}
          recentSearch={recentSearch}
          index={index}
          isSelected={index === selectedIndex}
          onSelect={onSelectRecentSearch}
        />
      ))}

      {!showRecentSearches && results.map((result, index) => (
        <SearchResultItem
          key={result.id}
          result={result}
          index={index}
          isSelected={index === selectedIndex}
          onSelect={onSelectResult}
        />
      ))}
    </div>
  );
});